export default __webpack_public_path__ + "static/media/givegift.af351268.png";